import { ActiveModelSerializer } from 'active-model-adapter';
import DS, { ModelSchema } from 'ember-data';
import { isPresent } from '@ember/utils';
import { UPDATE_TYPES } from 'cio/models/import';
import { ModelRegistry } from 'ember-data/model';

const { EmbeddedRecordsMixin } = DS;

const STATES = [UPDATE_TYPES.preprocess, UPDATE_TYPES.validate, UPDATE_TYPES.import];

export default class ImportSerializer extends ActiveModelSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    environment: {
      serialize: false,
    },
    user: {
      serialize: false,
      deserialize: 'records',
    },
    preprocessMeta: {
      serialize: false,
    },
    validateMeta: {
      serialize: false,
    },
    importMeta: {
      serialize: false,
    },
  },
}) {
  normalize(type: ModelSchema<keyof ModelRegistry>, hash: Record<string, any>, prop: string) {
    STATES.forEach((state) => {
      hash[`${state}_meta`] = JSON.parse((hash[`${state}_meta`] as string) || '{}');
      hash[`${state}_rules`] = JSON.parse((hash[`${state}_rules`] as string) || '{}');
    });

    return super.normalize(type, hash, prop);
  }

  serialize(snapshot: DS.Snapshot, options: Record<string, any>) {
    let json: Record<string, any> = super.serialize(snapshot, options);

    STATES.forEach((state) => {
      let key = `${state}_rules`;
      if (isPresent(json[key])) {
        json[key] = JSON.stringify(json[key]);
      }
    });

    return json;
  }
}
